export enum ApplicationProgressTypeEnum {
	New = 1,
	Activation = 2,
	Probation = 3,
	Reactivation = 4,
	AllApplications = 5
}
